import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import ShowMoreAndLess from "modules/product/showMoreAndLess/ShowMoreAndLessContainer";
import HideIf from "util/HideIf";
import Content from "./Content";
import styles from "./carPartsContent.module.scss";

function ContentSection(props) {
  const {
    heading, backgroundColor = "grey", content, article,
  } = props;
  return (
    <div className={`${styles.container} ${backgroundColor === "transparent" ? styles.transparent_background : styles.white_background}`}>
      <HideIf show={heading}>
        <PAText component="h2" className="m-t-0" fontSize={FONT_SIZE[5]} centerAlign bold>
          {heading}
        </PAText>
      </HideIf>
      <ShowMoreAndLess
        contentDescription={(
          <PAText className={styles.sub_content}>
            <Content content={content} article={article} />
          </PAText>
        )}
        defaultHeight={5}
        style={{ maxHeight: "calc(5 * var(--safari-root-font, 10px))" }}
        className={styles.show_more_less_container}
      />
    </div>
  );
}

export default ContentSection;
